const EventEmitter = require('wolfy87-eventemitter');
const GraphQLClient = require('./base');

function DummySocket() {}

class GraphqlClientLite extends GraphQLClient {
  _getSocketImplementation() {
    return DummySocket;
  }

  _getSocketOptions() {
    return { transport: WebSocket };
  }

  _getEventImplementation() {
    return EventEmitter;
  }
}

module.exports = GraphqlClientLite;
